export const environment = {
    production: true,
    api: "https://xpory.com/api/",
    api_blog: "https://blog.xpory.com/wp-json/wp/",
    title: 'XporY Permutas Multilaterais',
    theme_name: 'xpory',
    theme_css: '../../../themes/xpory',
    component_css: '../../../themes/xpory/css',
    component_json: '../../../../assets/theme/json',
    theme_assets: './assets/themes/xpory/',
    mostra_sebrae: true,
    label: {
        title: 'XporY',
        website: 'XporY.com',
    },
    firebaseConfig: {
        apiKey: 'AIzaSyARtdRofkNT4oK8xTKH-BRi5OfSPk-To4o',
        authDomain: 'xpory-images-617e8.firebaseapp.com',
        databaseURL: 'https://xpory-images-617e8.firebaseio.com',
        projectId: 'xpory-images-617e8',
        storageBucket: 'xpory-images-617e8.appspot.com',
        messagingSenderId: '752926108709',
        appId: '1:752926108709:web:099ba9497c057116d9a3cc',
        measurementId: 'G-77LXQ5BRX9',
    },
    googleAPI: 'AIzaSyDO-KzAl_oHb1CJGPoA15sMHgZ6p03mwpI'
};